import { EGlobalFetchingServices } from '~/composables/useGlobal';

export default {
  [EGlobalFetchingServices.ipbx + '1000']: 'شناسه دپارتمان قبلا ساخته شده',
  [EGlobalFetchingServices.ipbx + '1001']: 'شناسه دپارتمان نامعتبر است',
  [EGlobalFetchingServices.ipbx + '3000']: 'آیتم قبلا ساخته شده',

  [EGlobalFetchingServices.sms + '1000']:
    'گیرنده ای وجود ندارد یا همه ی گیرنده ها مسدود شده اند',
  [EGlobalFetchingServices.sms + '1001']: 'موجودی کافی نیست',
  [EGlobalFetchingServices.sms + '1002']: 'شماره معتبر نیست',
  [EGlobalFetchingServices.sms + '1003']: 'فرمت فایل معتبر نیست',
  [EGlobalFetchingServices.sms + '1004']: 'گروه یا مخاطب وجود ندارد',
  [EGlobalFetchingServices.sms + '1005']:
    'تعداد درخواست های شماره مشتری بیش از مقدار تعیین شده است',
  [EGlobalFetchingServices.sms + '1006']: 'قبلا برای این شماره درخواست ارسال شده',
  [EGlobalFetchingServices.sms + '1007']: 'قالب وجود ندارد',
  [EGlobalFetchingServices.sms + '1409']: 'مخاطب تکراری است',

  [EGlobalFetchingServices.invoice + '8001']: 'محصول موجود نیست',
  [EGlobalFetchingServices.invoice + '8002']: 'انتخاب محصول اجباری است',
  [EGlobalFetchingServices.invoice + '8003']:
    'تعداد هر محصول انتخاب شده باید بیشتر از صفر باشد',

  'Request Timeout': 'درخواست موفقیت آمیز نبود، دوباره تلاش کنید.',
  'Bad Request': 'ساختار درخواست نامعتبر است',
  Unauthorized: 'دسترسی غیرمجاز',
  Forbidden: 'دسترسی غیرمجاز',
  'Api Not Found': 'Api یافت نشد',
};
